import { addParentOptions } from '../actions/parentOptionsActions';
import getOptionsForPrimaryAccount from '../selectors/getOptionsForPrimaryAccount';
import { mutator } from 'satcheljs';

mutator(addParentOptions, ({ viewState, parentOptions }) => {
    const primaryAccountOptions = getOptionsForPrimaryAccount(viewState);

    if (primaryAccountOptions) {
        primaryAccountOptions.parentOptions = parentOptions;
    }
});
